import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import CardWithNumberNoBorder from "../generic/CardWithNumberNoBorder";
import { ReactComponent as GridDecoration } from "../../assets/decorations/blueBannerGridDataAnalytics.svg";

const GetStartedQuickly = () => {
  const cards = [
    {
      number: "1",
      title: "Integrate the SDK",
      subtitle: "Easy, one-time integration.",
    },
    {
      number: "2",
      title: "Automatic Data Collection",
      subtitle: "Immediately start capturing essential user and campaign data.",
    },
    {
      number: "3",
      title: "Analyze Clearly",
      subtitle:
        "Easily visualize and export data, empowering your team to drive results fast.",
    },
  ];
  return (
    <FullPageContainer>
      <DecorationWrapper>
        <GridDecoration />
      </DecorationWrapper>
      <Container id={"getStartedQuicklyDataAnalytics"}>
        <Title>Get Started Quickly</Title>
        <Content>
          {cards.map((item, index) => (
            <CardWithNumberNoBorder
              key={index}
              number={item.number}
              title={item.title}
              subtitle={item.subtitle}
            />
          ))}
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default GetStartedQuickly;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.landingPagePrimaryBackground};
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 60px 80px;
  gap: 20px;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  z-index: 2;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;
const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const DecorationWrapper = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  svg {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 990px) {
    svg {
      height: 100%;
      width: unset;
    }
  }
`;
